var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2801 4H20.1135V5.33333H22.1135V20H3.44679V5.33333H5.44679V4H3.28012C3.12428 4.0026 2.97048 4.03588 2.8275 4.09794C2.68452 4.15999 2.55517 4.24961 2.44683 4.36166C2.33849 4.47371 2.25328 4.60601 2.19608 4.751C2.13888 4.89599 2.1108 5.05083 2.11345 5.20667V20.1267C2.1108 20.2825 2.13888 20.4373 2.19608 20.5823C2.25328 20.7273 2.33849 20.8596 2.44683 20.9717C2.55517 21.0837 2.68452 21.1733 2.8275 21.2354C2.97048 21.2974 3.12428 21.3307 3.28012 21.3333H22.2801C22.436 21.3307 22.5898 21.2974 22.7327 21.2354C22.8757 21.1733 23.0051 21.0837 23.1134 20.9717C23.2218 20.8596 23.307 20.7273 23.3642 20.5823C23.4214 20.4373 23.4494 20.2825 23.4468 20.1267V5.20667C23.4494 5.05083 23.4214 4.89599 23.3642 4.751C23.307 4.60601 23.2218 4.47371 23.1134 4.36166C23.0051 4.24961 22.8757 4.15999 22.7327 4.09794C22.5898 4.03588 22.436 4.0026 22.2801 4Z",
    fill: "#516975"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11328 9.33398H7.44662V10.6673H6.11328V9.33398Z",
    fill: "#516975"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1133 9.33398H11.4466V10.6673H10.1133V9.33398Z",
    fill: "#516975"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1133 9.33398H15.4466V10.6673H14.1133V9.33398Z",
    fill: "#516975"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1133 9.33398H19.4466V10.6673H18.1133V9.33398Z",
    fill: "#516975"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11328 12.666H7.44662V13.9993H6.11328V12.666Z",
    fill: "#516975"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1133 12.666H11.4466V13.9993H10.1133V12.666Z",
    fill: "#516975"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1133 12.666H15.4466V13.9993H14.1133V12.666Z",
    fill: "#516975"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1133 12.666H19.4466V13.9993H18.1133V12.666Z",
    fill: "#516975"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11328 16H7.44662V17.3333H6.11328V16Z",
    fill: "#516975"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1133 16H11.4466V17.3333H10.1133V16Z",
    fill: "#516975"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1133 16H15.4466V17.3333H14.1133V16Z",
    fill: "#516975"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1133 16H19.4466V17.3333H18.1133V16Z",
    fill: "#516975"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44645 6.66732C7.62326 6.66732 7.79283 6.59708 7.91786 6.47205C8.04288 6.34703 8.11312 6.17746 8.11312 6.00065V2.00065C8.11312 1.82384 8.04288 1.65427 7.91786 1.52925C7.79283 1.40422 7.62326 1.33398 7.44645 1.33398C7.26964 1.33398 7.10007 1.40422 6.97505 1.52925C6.85002 1.65427 6.77979 1.82384 6.77979 2.00065V6.00065C6.77979 6.17746 6.85002 6.34703 6.97505 6.47205C7.10007 6.59708 7.26964 6.66732 7.44645 6.66732Z",
    fill: "#516975"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18.113 6.66732C18.2898 6.66732 18.4593 6.59708 18.5844 6.47205C18.7094 6.34703 18.7796 6.17746 18.7796 6.00065V2.00065C18.7796 1.82384 18.7094 1.65427 18.5844 1.52925C18.4593 1.40422 18.2898 1.33398 18.113 1.33398C17.9361 1.33398 17.7666 1.40422 17.6416 1.52925C17.5165 1.65427 17.4463 1.82384 17.4463 2.00065V6.00065C17.4463 6.17746 17.5165 6.34703 17.6416 6.47205C17.7666 6.59708 17.9361 6.66732 18.113 6.66732Z",
    fill: "#516975"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44629 4H16.113V5.33333H9.44629V4Z",
    fill: "#516975"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.3843857dd036f67e227fc57f88e7ee5c.svg";
export { ForwardRef as ReactComponent };